export const CATALOG_RELATIONSHIP_IDS = {
  FAMILY: '1',
  FRIEND: '2',
  COWORKER: '3',
  NEIGHBOR: '4',
};
